export const apiRoutes = {
  equipment: {
    historyReport: {
      page: () => 'api/v2/equipment/history-report/page',
      filteredListPost: (page: number, pageSize: number) =>
        `api/v2/equipment/history-report/filter?page=${page}&pageSize=${pageSize}`,
      exportCsv: () => 'api/v2/equipment/history-report/export/csv',
      detail: (equipmentId: number) => `api/v2/equipment/history-report/${equipmentId}`
    }
  },
  purchaseOrderReport: {
    page: () => 'api/v2/purchasing/purchase-order-report/page',
    filteredListPost: (page: number, pageSize: number) =>
      `api/v2/purchasing/purchase-order-report/filter?page=${page}&pageSize=${pageSize}`,
    exportCsv: () => 'api/v2/purchasing/purchase-order-report/export/csv',
    create: () => 'api/v2/purchasing/purchase-order-report',
    editor: (purchaseOrderId: number) => `api/v2/purchasing/purchase-order-report/${purchaseOrderId}`,
    approvalSeed: (purchaseOrderId: number) => `api/v2/purchasing/purchase-order-report/${purchaseOrderId}/approval`,
    approve: (purchaseOrderId: number) => `api/v2/purchasing/purchase-order-report/${purchaseOrderId}/approval`,
    delete: (purchaseOrderId: number) => `api/v2/purchasing/purchase-order-report/${purchaseOrderId}`
  },
  invoiceNumberReport: {
    page: () => 'api/v2/invoicing/invoice-number-report/years',
    filteredListPost: (page: number, pageSize: number, orderBy?: string, isDesc?: boolean) => {
      let url = `api/v2/invoicing/invoice-number-report/filter?page=${page}&pageSize=${pageSize}`;
      if (orderBy !== undefined) url += `&orderBy=${orderBy}`;
      if (isDesc !== undefined) url += `&isDesc=${isDesc}`;
      return url;
    }
  },
  invoiceApproval: {
    page: () => 'api/v2/invoicing/invoice-approval/page',
    filteredListPost: (page: number, pageSize: number) =>
      `api/v2/invoicing/invoice-approval/filter?page=${page}&pageSize=${pageSize}`,
    approve: (invoiceId: number) => `api/v2/invoicing/invoice-approval/${invoiceId}/approve`,
    reject: (invoiceId: number) => `api/v2/invoicing/invoice-approval/${invoiceId}/reject`,
    unlock: (invoiceId: number) => `api/v2/invoicing/invoice-approval/${invoiceId}/unlock`
  },
  timesheetSummaryReport: {
    page: (fieldTimeOnly: boolean) => `api/v2/reporting/timesheet-summary/page?fieldTimeOnly=${fieldTimeOnly}`,
    filteredListPost: (page: number, pageSize: number) =>
      `api/v2/reporting/timesheet-summary/filter?page=${page}&pageSize=${pageSize}`,
    exportCsv: () => 'api/v2/reporting/timesheet-summary/export/csv',
    summaryPdf: () => 'api/v2/reporting/timesheet-summary/summary-pdf',
    timesheetsPdf: () => 'api/v2/reporting/timesheet-summary/timesheets-pdf'
  },
  equipmentUsageReport: {
    page: () => 'api/v2/reporting/equipment-usage-report/page',
    table: () => 'api/v2/reporting/equipment-usage-report/table'
  },
  safetyTicketReport: {
    page: () => 'api/v2/safety/safety-ticket-report/page',
    filteredListPost: (page: number, pageSize: number) =>
      `api/v2/safety/safety-ticket-report/filter?page=${page}&pageSize=${pageSize}`,
    exportCsv: () => 'api/v2/safety/safety-ticket-report/export/csv'
  },
  quickLinks: {
    list: (showInNavOnly?: boolean) => `api/v2/quick-links${showInNavOnly === true ? '?showInNavOnly=true' : ''}`,
    create: () => 'api/v2/quick-links',
    update: (quickLinkId: number) => `api/v2/quick-links/${quickLinkId}`,
    delete: (quickLinkId: number) => `api/v2/quick-links/${quickLinkId}`,
    download: (quickLinkId: number) => `api/v2/quick-links/${quickLinkId}/download`,
    navigation: () => 'api/v2/quick-links?showInNavOnly=true'
  },
  jobs: {
    search: (term: string) => `api/JobSearch/search?term=${encodeURIComponent(term)}`
  },
  jobBook: {
    page: () => 'api/v2/jobs',
    year: (year: number) => `api/v2/jobs/year/${year}`,
    filter: (orderBy?: string, isDesc?: boolean) => {
      let url = 'api/v2/jobs/filter';
      const queryParams: string[] = [];
      if (orderBy !== undefined) queryParams.push(`orderBy=${encodeURIComponent(orderBy)}`);
      if (isDesc !== undefined) queryParams.push(`isDesc=${isDesc}`);
      if (queryParams.length > 0) url += `?${queryParams.join('&')}`;
      return url;
    },
    delete: (jobId: number) => `api/v2/jobs/${jobId}`,
    location: {
      create: () => 'api/v2/jobs/location',
      delete: (locationId: number) => `api/v2/jobs/location/${locationId}`,
      get: (locationId: number) => `api/v2/jobs/location/${locationId}`
    },
    editor: {
      page: (query: string) => `api/v2/jobs/editor?${query}`,
      save: () => 'api/v2/jobs/editor/save',
      lock: () => 'api/v2/jobs/editor/lock',
      copy: (copies: number) => `api/v2/jobs/editor/copy?copies=${copies}`,
      revise: () => 'api/v2/jobs/editor/revise',
      reviseOpenJobsCheck: (compassId: number, jobYear: number) =>
        `api/v2/jobs/editor/revise/open-jobs-check?compassId=${compassId}&jobYear=${jobYear}`,
      locationJobSearch: () => 'api/v2/jobs/editor/locations/job-search',
      cascade: {
        jobSubTypes: (jobTypeId: number) => `api/v2/jobs/editor/cascade/jobSubTypes?jobTypeId=${jobTypeId}`,
        jobActivities: (jobTypeId: number) => `api/v2/jobs/editor/cascade/jobActivities?jobTypeId=${jobTypeId}`,
        clientManagers: (clientId: number) => `api/v2/jobs/editor/cascade/clientManagers?clientId=${clientId}`,
        primaryContact: (clientId: number) => `api/v2/jobs/editor/cascade/primaryContact?clientId=${clientId}`,
        clientContactInfo: (contactId: number) => `api/v2/jobs/editor/cascade/clientContactInfo?contactId=${contactId}`
      }
    },
    workspace: {
      invoices: (jobId: number) => `api/v2/jobs/${jobId}/workspace/invoices`,
      timeSummary: (jobId: number) => `api/v2/jobs/${jobId}/workspace/time-summary`,
      timeSummaryTransfer: (jobId: number) => `api/v2/jobs/${jobId}/workspace/time-summary/transfer`,
      history: (jobId: number) => `api/v2/jobs/${jobId}/workspace/history`,
      purchases: (jobId: number) => `api/v2/jobs/${jobId}/workspace/purchases`,
      purchaseVendors: (jobId: number) => `api/v2/jobs/${jobId}/workspace/purchases/vendors`,
      purchaseDelete: (jobId: number, purchaseId: number) => `api/v2/jobs/${jobId}/workspace/purchases/${purchaseId}`,
      purchaseSave: (jobId: number) => `api/v2/jobs/${jobId}/workspace/purchases`,
      purchaseTransfer: (jobId: number) => `api/v2/jobs/${jobId}/workspace/purchases/transfer`,
      files: (jobId: number) => `api/v2/jobs/${jobId}/workspace/files`,
      fileDownload: (jobId: number, fileName: string) =>
        `api/v2/jobs/${jobId}/workspace/files/download?fileName=${encodeURIComponent(fileName)}`,
      fileDelete: (jobId: number, fileName: string) =>
        `api/v2/jobs/${jobId}/workspace/files?fileName=${encodeURIComponent(fileName)}`,
      fileUpload: (jobId: number) => `api/v2/jobs/${jobId}/workspace/files`
    },
    selectOptions: {
      contacts: (companyId: number) => `api/v2/jobs/selectOptions/contacts?companyId=${companyId}`,
      jobSubTypes: (jobTypeIds: number[]) =>
        `api/v2/jobs/selectOptions/jobSubTypes?${jobTypeIds.map((id) => `jobTypeIds=${id}`).join('&')}`,
      locationTypes: (jobTypeIds: number[]) =>
        `api/v2/jobs/selectOptions/locationTypes?${jobTypeIds.map((id) => `jobTypeIds=${id}`).join('&')}`,
      locationSubTypes: (locationType: string) =>
        `api/v2/jobs/selectOptions/locationSubTypes?locationType=${encodeURIComponent(locationType)}`
    }
  },
  userManagement: {
    filteredListPost: (page: number, pageSize: number, orderBy?: string, isDesc?: boolean) => {
      let url = `api/admin/userManagement/filter?page=${page}&pageSize=${pageSize}`;
      if (orderBy !== undefined) url += `&orderBy=${orderBy}`;
      if (isDesc !== undefined) url += `&isDesc=${isDesc}`;
      return url;
    },
    getBasicInfo: (userId: string) => `api/admin/userManagement/${userId}/basicInfo`,
    updateBasicInfo: (userId: string) => `api/admin/userManagement/${userId}/basicInfo`,
    create: () => `api/admin/userManagement/create`,
    activities: (userId: string) => `api/admin/userManagement/${userId}/activities`,
    emergencyContacts: (userId: string) => `api/admin/userManagement/${userId}/emergencyContacts`,
    deleteEmergencyContact: (userId: string, contactId: number) =>
      `api/admin/userManagement/${userId}/emergencyContacts/${contactId}`,
    safetyTickets: (userId: string) => `api/admin/userManagement/${userId}/safetyTickets`,
    removeSafetyTicket: (userId: string, ticketId: number) =>
      `api/admin/userManagement/${userId}/safetyTickets/${ticketId}`,
    updateSafetyTicketExpiry: (userId: string, ticketId: number) =>
      `api/admin/userManagement/${userId}/safetyTickets/${ticketId}/expiry`,
    safetyTicketDocuments: (userId: string) => `api/admin/userManagement/${userId}/safetyTicketDocuments`,
    downloadSafetyTicketDocument: (userId: string, fileName: string) =>
      `api/admin/userManagement/${userId}/safetyTicketDocuments/download?fileName=${encodeURIComponent(fileName)}`,
    deleteSafetyTicketDocument: (userId: string, fileName: string) =>
      `api/admin/userManagement/${userId}/safetyTicketDocuments?fileName=${encodeURIComponent(fileName)}`,
    bankTime: (userId: string) => `api/admin/userManagement/${userId}/bankTime`,
    replacement: (userId: string) => `api/admin/userManagement/${userId}/replacement`
  },
  hrManagement: {
    verifyPassword: () => 'api/v2/hr/verify-password',
    users: () => 'api/v2/hr/users',
    reminders: (userId: string) => `api/v2/hr/users/${userId}/reminders`,
    reminder: (userId: string, reminderId: number) => `api/v2/hr/users/${userId}/reminders/${reminderId}`,
    notes: (userId: string) => `api/v2/hr/users/${userId}/notes`,
    note: (userId: string, noteId: number) => `api/v2/hr/users/${userId}/notes/${noteId}`,
    documents: (userId: string, documentType: string) =>
      `api/v2/hr/users/${userId}/documents?documentType=${encodeURIComponent(documentType)}`,
    createDocument: (userId: string) => `api/v2/hr/users/${userId}/documents`,
    updateDocument: (userId: string, documentId: number) => `api/v2/hr/users/${userId}/documents/${documentId}`,
    deleteDocument: (userId: string, documentId: number) => `api/v2/hr/users/${userId}/documents/${documentId}`,
    downloadDocument: (userId: string, documentId: number) =>
      `api/v2/hr/users/${userId}/documents/${documentId}/download`
  },
  companyCrm: {
    filteredListPost: (page: number, pageSize: number, orderBy?: string, isDesc?: boolean) => {
      let url = `api/v2/crm/companies/filter?page=${page}&pageSize=${pageSize}`;
      if (orderBy !== undefined) url += `&orderBy=${orderBy}`;
      if (isDesc !== undefined) url += `&isDesc=${isDesc}`;
      return url;
    },
    exportExcel: (orderBy?: string, isDesc?: boolean) => {
      let url = 'api/v2/crm/companies/export/excel';
      const queryParams: string[] = [];
      if (orderBy !== undefined) queryParams.push(`orderBy=${encodeURIComponent(orderBy)}`);
      if (isDesc !== undefined) queryParams.push(`isDesc=${isDesc}`);
      if (queryParams.length > 0) url += `?${queryParams.join('&')}`;
      return url;
    },
    delete: (companyId: number) => `api/v2/crm/companies/${companyId}`,
    getBasicInfo: (companyId: number) => `api/v2/crm/companies/${companyId}/basicInfo`,
    updateBasicInfo: (companyId: number) => `api/v2/crm/companies/${companyId}/basicInfo`,
    create: () => 'api/v2/crm/companies',
    contacts: (companyId: number) => `api/v2/crm/companies/${companyId}/contacts`,
    exportContactsExcel: (companyId: number) => `api/v2/crm/companies/${companyId}/contacts/export/excel`,
    updateContact: (companyId: number, contactId: number) => `api/v2/crm/companies/${companyId}/contacts/${contactId}`,
    deleteContact: (companyId: number, contactId: number) => `api/v2/crm/companies/${companyId}/contacts/${contactId}`,
    documents: (companyId: number, documentType: string) =>
      `api/v2/crm/companies/${companyId}/documents?documentType=${encodeURIComponent(documentType)}`,
    createDocument: (companyId: number) => `api/v2/crm/companies/${companyId}/documents`,
    updateDocument: (companyId: number, documentId: number) =>
      `api/v2/crm/companies/${companyId}/documents/${documentId}`,
    deleteDocument: (companyId: number, documentId: number) =>
      `api/v2/crm/companies/${companyId}/documents/${documentId}`,
    downloadDocument: (companyId: number, documentId: number) =>
      `api/v2/crm/companies/${companyId}/documents/${documentId}/download`,
    notes: (companyId: number, companyContactId?: number) =>
      `api/v2/crm/companies/${companyId}/notes${
        companyContactId !== undefined ? `?companyContactId=${companyContactId}` : ''
      }`,
    deleteNote: (companyId: number, noteId: number) => `api/v2/crm/companies/${companyId}/notes/${noteId}`,
    updateNote: (companyId: number, noteId: number) => `api/v2/crm/companies/${companyId}/notes/${noteId}`,
    selectOptions: {
      users: () => 'api/v2/crm/companies/selectOptions/users',
      provinces: () => 'api/v2/crm/companies/selectOptions/provinces',
      invoiceTemplates: () => 'api/v2/crm/companies/selectOptions/invoiceTemplates',
      companyTypes: () => 'api/v2/crm/companies/selectOptions/companyTypes',
      companySubTypes: () => 'api/v2/crm/companies/selectOptions/companySubTypes',
      cities: () => 'api/v2/crm/companies/selectOptions/cities',
      lineOfBusinesses: () => 'api/v2/crm/companies/selectOptions/lineOfBusinesses',
      invoiceRulesets: () => 'api/v2/crm/companies/selectOptions/invoiceRulesets'
    }
  },
  util: {
    selectOption: {
      enumType: (type: string) => `/selectOption/enum/${type}`,
      users: () => `/selectoption/users`,
      departments: () => `/selectoption/departments`,
      workLocations: () => `/selectoption/workLocations`,
      provinces: () => `/selectoption/provinces`,
      officeTimeActivities: () => `/selectoption/officeTimeActivities`,
      fieldTimeTypes: () => `/selectoption/fieldTimeTypes`,
      safetyTicketItems: () => `/selectoption/safetyTicketItems`,
      usersInRoles: (roles: string[]) => {
        let toReturn = `/selectoption/UsersInRoles`;
        roles.forEach((role) => {
          if (toReturn.indexOf('?') >= 0) {
            toReturn += `&roles=${role}`;
          } else {
            toReturn += `?roles=${role}`;
          }
        });
        return toReturn;
      }
    }
  }
};
